
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/services/studio/application-development",
      function () {
        return require("private-next-pages/services/studio/application-development.tsx");
      }
    ]);
  